import { lazy } from "react";
import { ROUTE_PERMISSIONS } from "@/config/navigation";

/**
 * HR module routes — permissions mirror component keys in config/navigation.js.
 */
export const HR_ROUTES = [
  {
    path: "/hr/dashboard",
    permission: ROUTE_PERMISSIONS["/hr/dashboard"],
    Component: lazy(() => import("@/modules/hr/pages/HRDashboard")),
  },
  {
    path: "/hr/attendance",
    permission: ROUTE_PERMISSIONS["/hr/attendance"],
    Component: lazy(() => import("@/modules/hr/pages/AttendanceMonitoring")),
  },
  {
    path: "/hr/leaves",
    permission: ROUTE_PERMISSIONS["/hr/leaves"],
    Component: lazy(() => import("@/modules/hr/pages/LeaveManagement")),
  },
  {
    path: "/hr/geofences",
    permission: ROUTE_PERMISSIONS["/hr/geofences"],
    Component: lazy(() => import("@/modules/hr/pages/Geofences")),
  },
  {
    path: "/hr/employees",
    permission: ROUTE_PERMISSIONS["/hr/employees"],
    Component: lazy(() => import("@/modules/hr/pages/EmployeeManagement")),
  },
];
